import { render, staticRenderFns } from "./footerCase.vue?vue&type=template&id=41ed410b&scoped=true"
import script from "./footerCase.vue?vue&type=script&lang=js"
export * from "./footerCase.vue?vue&type=script&lang=js"
import style0 from "./footerCase.vue?vue&type=style&index=0&id=41ed410b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed410b",
  null
  
)

export default component.exports